import { defineMessages } from 'react-intl-next';

export const messages: {
	landingPrimary: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	landingSecondary: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	landingPrimary: {
		id: 'dynamic-cards-search-page.landing_primary',
		defaultMessage: 'Get started with filters for dynamic cards',
		description: 'Message shown to prompt users to select filters',
	},
	landingSecondary: {
		id: 'dynamic-cards-search-page.landing_secondary',
		defaultMessage: 'Define your rules to automatically build cards',
		description: 'Additional message to prompt users to select filters',
	},
});
